import { render } from "./configure-page.vue?vue&type=template&id=9f5f6486&scoped=true&ts=true"
import script from "./configure-page.vue?vue&type=script&lang=ts"
export * from "./configure-page.vue?vue&type=script&lang=ts"

import "./configure-page.vue?vue&type=style&index=0&id=9f5f6486&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f5f6486"]])

export default __exports__